var CartShippingRates={
 async load(fetcher,root,country,zip){
  if(!zip.trim())throw new Error('zip');
  const params=new URLSearchParams({'shipping_address[country]':country,'shipping_address[zip]':zip.trim()});
  const response=await fetcher(root+'cart/prepare_shipping_rates.json?'+params,{method:'POST'});
  if(!response.ok)throw new Error(String(response.status));
  for(let i=0;i<3;i++){
   const rates=await fetcher(root+'cart/async_shipping_rates.json?'+params);
   if(!rates.ok)throw new Error(String(rates.status));
   const data=await rates.json();if(data&&Array.isArray(data.shipping_rates))return data.shipping_rates;
   await new Promise(resolve=>setTimeout(resolve,500*(i+1)));
  }
  throw new Error('pending');
 }
};
if(typeof document!=='undefined')customElements.define('cart-shipping-estimator',class extends HTMLElement{
 connectedCallback(){
  const button=this.querySelector('button'),input=this.querySelector('input'),status=this.querySelector('[role=status]');
  const apply=async()=>{
   if(button.disabled)return;button.disabled=true;status.textContent=this.dataset.loading;
   try{
    const country={CH:'Switzerland',LI:'Liechtenstein',DE:'Germany',AT:'Austria'}[this.dataset.country]||this.dataset.country;
    const rates=await CartShippingRates.load(fetch,Shopify.routes.root,country,input.value);
    if(!rates.length)throw new Error('no rates');
    const format=new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:this.dataset.currency});
    status.replaceChildren(...rates.map(rate=>{const row=document.createElement('p');row.textContent=rate.name+': '+format.format(Number(rate.price));return row;}));
    const note=document.createElement('small');note.textContent=this.dataset.note;status.append(note);
   }catch(error){status.textContent=this.dataset.error;}
   finally{button.disabled=false;}
  };
  button.addEventListener('click',apply);input.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();apply();}});
 }
});
